(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('CompaniesController', companies);

  companies.$inject = ['$http', '$state', 'ngTableParams'];

  function companies ($http, $state, ngTableParams) {
    var vm = this;

    vm.name = undefined;
    vm.domain = undefined;

    vm.companiesTable = new ngTableParams({
      page: 1,
      count: 10
    }, {
      getData: function ($defer, params) {
        $http.get(apiUrl + '/companies/paged', {
          params: params.url()
        }).then(function (response) {
          params.total(response.total);
          $defer.resolve(response.data);
        }, function (error) { console.log(error) });
      }
    });

    vm.saveCompany = function (data) {
      $http.post(apiUrl + '/companies', {
        name: vm.name,
        domain: vm.domain,
        view_data: ''
      }).then(function (response) {
        $state.go('main.edit-company', { id: response.data.id });
      }, function (error) { console.log(error) });
    };

    vm.createContract = function (company) {
      $http.post(apiUrl + '/contracts', {
        company_id: company.id
      }).then(function (response) {
        $state.go('main.contract', { id: response.data.id });
      }, function (error) { console.log(error) });
    };
  }
})();
